/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { MenuProvider } from './menu-provider.interface';
import { Injectable, inject } from '@angular/core';
import { MENU_PROVIDERS } from '../menu.config';
import { ProviderMenuItem } from './menu-item.interface';
import { combineLatest, Observable, of, ReplaySubject } from 'rxjs';

@Injectable()
export class MenuProviderHandler {
  menuProviders: Array<MenuProvider> | undefined = undefined;
  providerMenuItem: any;
  observables: Observable<any>[] = [];

  constructor() {
    this.menuProviders = inject(MENU_PROVIDERS);
  }

  registerSubscribers() {
    this.observables = this.menuProviders ? this.menuProviders.map((menuProvider: MenuProvider) => {
      const menuItems = menuProvider.getMenuItems();
      if (menuItems instanceof ReplaySubject) {
        return menuItems.asObservable();
      } else {
        return of(menuItems);
      }
    }) : [];
  }

  getProviderMenuItem(): Observable<ProviderMenuItem[][]> {
    this.registerSubscribers();
    this.providerMenuItem = combineLatest(...this.observables);
    return this.providerMenuItem;
  }
}
